import moment from 'moment'

var field = {
  width: '100px',
  display: 'inline-block',
  paddingRight: '6px',
  textAlign: 'left'
}

export const data = () => ({
  isDebug: true,
  toggle: false,
  requestCount: 1,
  loading: false,
  selectedGarage: null,
  garages: [],
  statusFilter: 'all',
  formatDateFn: function(value) {
    return value != null ? moment(value, 'YYYY/MM/DD HH:mm:ss').format('MM-DD-YYYY') : ''
  },

  filters: {
    show: true
  },

  region: {},

  rows: [],

  columns: [
    {
      field: 'garageNumber',
      numeric: true,
      label: 'Number',
      aria: 'Number',
      width: '3%',
      sortable: true,
      searchable: true
    },
    {
      field: 'vehicleCapacity',
      label: 'Vehicle Cap.',
      aria: 'Vehicle Cap.',
      width: '15%',
      sortable: true,
      searchable: true
    },
    {
      field: 'areaSquareFeet',
      label: 'Square Feet',
      aria: 'Square Feet',
      width: '15%',
      sortable: true,
      searchable: true
    },
    {
      field: 'unit',
      label: 'Unit',
      aria: 'Unit',
      width: '40%',
      sortable: true,
      searchable: true
    }
  ],

  styles: {
    formRow: {
      padding: '10px',
      whiteSpace: 'nowrap'
    },
    filterButton: {
      float: 'right',
      marginTop: '4px'
    },
    amountField: Object.assign({}, field, {
      width: '125px'
    })
  }
})
